import React from "react";

function ExchangeListingHero() {
  return (
    <>
      <div
        className="banner-style-six-area bg-theme text-light bg-cover"
        style={{
          background:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-18.jpg)",
        }}
      >
        <div className="container">
          <div className="banner-six-top-info">
            <div className="row">
              <div className="col-xl-6 col-lg-6">
                <h2 className="split-lines">
                  List Your Coin/Token on Leading Crypto Exchanges
                </h2>
              </div>
              <div className="col-xl-5 offset-xl-1 col-lg-6">
                <p>
                  We provide end-to-end support for crypto projects aiming to
                  list their tokens on top exchanges!
                </p>
                {/* <a
                    href=""
                    className="btn btn-style-one light mt-10"
                  >
                    Join Today
                  </a> */}
              </div>
            </div>
          </div>
          <div className="banner-bottom-info">
            <div className="row">
              <div className="col-lg-4">
                <div
                  className="community-card-two bg-theme text-light bg-cover shadow theme"
                  style={{
                    backgroundImage:
                      "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-2.jpg)",
                  }}
                >
                  <h4>AI Community</h4>
                  <p>
                    Join the design community and unleash your creative studio
                  </p>
                  <div className="multi-users">
                    <i className="fas fa-plus" />
                    <h5>10M User</h5>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="thumb">
                  <img
                    src="https://validthemes.net/site-template/robok/assets/img/banner/4.jpg"
                    alt="Image Not Found"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ExchangeListingHero;
